// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__XXnEy","form":"styles_form__1r15a"};